import { render } from "./RegInvoice.vue?vue&type=template&id=d384cca6"
import script from "./RegInvoice.vue?vue&type=script&lang=js"
export * from "./RegInvoice.vue?vue&type=script&lang=js"

import "./RegInvoice.vue?vue&type=style&index=0&id=d384cca6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__